import { GuidService } from 'ui-components/services/guid-service';
import { makeOptimisticMeta, CSW_RATE_ACTION_FAILURE } from './optimistic-helpers/actions-update';
import {
  BEGIN_OPTIMISTIC_UPDATE,
  COMMIT_OPTIMISTIC_UPDATE,
  REVERT_OPTIMISTIC_UPDATE,
  FLUSH_OPTIMISTIC_UPDATE,
} from '../optimistic.update.reducer';

export const CSW_CREATE_LABEL = 'CSW_CREATE_LABEL';
export const CSW_CREATE_LABEL_PRE_SUCCESS = 'CSW_CREATE_LABEL_PRE_SUCCESS';
export const CSW_CREATE_LABEL_SUCCESS = 'CSW_CREATE_LABEL_SUCCESS';
export const CSW_CREATE_LABEL_FAILURE = 'CSW_CREATE_LABEL_FAILURE';
export const CSW_SAVE_MULTIPACKAGE_SET = 'CSW_SAVE_MULTIPACKAGE_SET';
export const CSW_SETUP_MULTI_PACKAGE = 'CSW_SETUP_MULTI_PACKAGE';
export const CSW_CLEAR_MULTI_PACKAGE = 'CSW_CLEAR_MULTI_PACKAGE';
export const CSW_UPDATE_SHIPMENT_CONFIGURATION_OPTIONS = 'CSW_UPDATE_SHIPMENT_CONFIGURATION_OPTIONS';
export const CSW_START_UPDATE_AVAILABLE_SHIPPING_SERVICES = 'CSW_START_UPDATE_AVAILABLE_SHIPPING_SERVICES';
export const CSW_UPDATE_AVAILABLE_SHIPPING_SERVICES = 'CSW_UPDATE_AVAILABLE_SHIPPING_SERVICES';
export const CSW_UPDATE_SERVICE_AND_OTHER_SHIPPING_OPTIONS = 'CSW_UPDATE_SERVICE_AND_OTHER_SHIPPING_OPTIONS';
export const CSW_SAVE_PACKAGE_SET_SUCCESS = 'CSW_SAVE_PACKAGE_SET_SUCCESS';
export const CSW_CHANGE_INSURED_VALUE = 'CSW_CHANGE_INSURED_VALUE';
export const CSW_UPDATE_CREATE_MULTIPACKAGE_CONFIGURATION_PACKAGES = 'CSW_UPDATE_CREATE_MULTIPACKAGE_CONFIGURATION_PACKAGES';
export const CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_SUCCESS = 'CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_SUCCESS';
export const CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_FAILURE = 'CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_FAILURE';
export const CSW_RESET = 'CSW_RESET';
export const CSW_EXIT_RETURNS_MODE = 'CSW_EXIT_RETURNS_MODE';
export const CSW_CREATE_TEST_LABEL = 'CSW_CREATE_TEST_LABEL';
export const CSW_CREATE_TEST_LABEL_SUCCESS = 'CSW_CREATE_TEST_LABEL_SUCCESS';
export const CSW_CREATE_TEST_LABEL_FAILURE = 'CSW_CREATE_TEST_LABEL_FAILURE';

// TODO: we should eventually move away from having to "setup" the shipment configuration state
//  and it should be populated ad-hoc when fields change
export const CSW_INIT_SHIPMENT_CONFIGURATION = 'CSW_INIT_SHIPMENT_CONFIGURATION';
export const initShipmentConfiguration = (fulfillmentPlanId, cswTypeId) => ({
  type: CSW_INIT_SHIPMENT_CONFIGURATION,
  fulfillmentPlanId,
  cswTypeId,
});

export const INIT_CSW_GLOBAL_LISTENERS = 'INIT_CSW_GLOBAL_LISTENERS';
export const initCswGlobalListener = ({ fulfillmentPlanId, callback, bulkUpdateFinishedHandler }) => {
  return {
    type: INIT_CSW_GLOBAL_LISTENERS,
    fulfillmentPlanId,
    callback,
    bulkUpdateFinishedHandler,
  };
};

export const UNBIND_CSW_GLOBAL_LISTENERS = 'UNBIND_CSW_GLOBAL_LISTENERS';
export const unbindCswGlobalListener = ({ fulfillmentPlanId }) => {
  return {
    type: UNBIND_CSW_GLOBAL_LISTENERS,
    fulfillmentPlanId,
  };
};

export const SYNC_CSW_TO_ENTITIES = 'SYNC_CSW_TO_ENTITIES';
export const syncCswToEntities = () => ({
  type: SYNC_CSW_TO_ENTITIES,
});

export const CSW_UPDATE_TYPE = 'CSW_UPDATE_TYPE';
export const updateCSWType = ({ cswTypeId, fulfillmentPlanId }) => ({
  cswTypeId,
  fulfillmentPlanId,
  type: CSW_UPDATE_TYPE,
});

export const CSW_SETUP_SHIPMENT_CONFIGURATION = 'CSW_SETUP_SHIPMENT_CONFIGURATION';
export const setupShipmentConfiguration = (fulfillmentPlanId, updatePayload, otherConfiguration) => ({
  type: CSW_SETUP_SHIPMENT_CONFIGURATION,
  fulfillmentPlanId,
  updatePayload,
  otherConfiguration,
});

export const CSW_UPDATE_SHIPMENT_CONFIGURATION = 'CSW_UPDATE_SHIPMENT_CONFIGURATION';
export const updateShipmentConfiguration = (fulfillmentPlanId, updatePayload, isEnteringExternalFulfillment) => {
  const optimisticId = GuidService.newGuid();
  return {
    fulfillmentPlanId,
    isEnteringExternalFulfillment,
    type: CSW_UPDATE_SHIPMENT_CONFIGURATION,
    updatePayload,
    meta: {
      ...makeOptimisticMeta(fulfillmentPlanId, optimisticId),
    },
  };
};

export const updateShipmentConfigurationOptions = (fulfillmentPlanId, optionName, optionValue) => {
  const optimisticId = GuidService.newGuid();
  return {
    fulfillmentPlanId,
    optionName,
    optionValue,
    type: CSW_UPDATE_SHIPMENT_CONFIGURATION_OPTIONS,
    meta: {
      ...makeOptimisticMeta(fulfillmentPlanId, optimisticId),
    },
  };
};

export const CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES = 'CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES';
export const updateShipmentConfigurationPackages = (fulfillmentPlanId, updatePayload, index = 0, preserveNonZeroIndex = false) => {
  const optimisticId = GuidService.newGuid();
  return {
    fulfillmentPlanId,
    index,
    preserveNonZeroIndex,
    type: CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES,
    updatePayload,
    meta: {
      ...makeOptimisticMeta(fulfillmentPlanId, optimisticId),
    },
  };
};

export const CSW_CHANGE_INSURANCE_VALUE_ON_ALL_PACKAGES = 'CSW_CHANGE_INSURANCE_VALUE_ON_ALL_PACKAGES';
export const changeInsuranceValueOnAllPackages = (fulfillmentPlanId, updatePayload) => ({
  type: CSW_CHANGE_INSURANCE_VALUE_ON_ALL_PACKAGES,
  fulfillmentPlanId,
  updatePayload,
});

export const startUpdateAvailableShippingServices = (fulfillmentPlanId, updatedShipFromId) => ({
  type: CSW_START_UPDATE_AVAILABLE_SHIPPING_SERVICES,
  fulfillmentPlanId,
  updatedShipFromId,
});

export const updateAvailableShippingServices = (fulfillmentPlanId, updatedAvailableShippingServices) => ({
  type: CSW_UPDATE_AVAILABLE_SHIPPING_SERVICES,
  fulfillmentPlanId,
  updatedAvailableShippingServices,
});

export const CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES_FROM_PRESET = 'CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES_FROM_PRESET';
export const updateShipmentConfigurationPackagesFromPreset = (fulfillmentPlanId, updatePayload) => {
  const optimisticId = GuidService.newGuid();
  return {
    fulfillmentPlanId,
    type: CSW_UPDATE_SHIPMENT_CONFIGURATION_PACKAGES_FROM_PRESET,
    updatePayload,
    meta: {
      ...makeOptimisticMeta(fulfillmentPlanId, optimisticId),
    },
  };
};

export const createLabel = (
  fulfillmentPlanId,
  autoPrint = false,
  doNotPrint = false,
  ignoreWarnings = false,
  showOrderDetailsOnError = false,
) => ({
  type: CSW_CREATE_LABEL,
  fulfillmentPlanId,
  autoPrint,
  doNotPrint,
  ignoreWarnings,
  showOrderDetailsOnError,
});

export const createLabelSuccess = (fulfillmentPlanId, labelObject, autoPrint, doNotPrint, { sourceHasHandled }) => ({
  type: CSW_CREATE_LABEL_SUCCESS,
  fulfillmentPlanId,
  labelObject,
  autoPrint,
  doNotPrint,
  sourceHasHandled,
});

export const createLabelFailure = (
  fulfillmentPlanId,
  errorMessages,
  autoPrint,
  isLabelPurchaseComplete = false,
  purchaseCorrelationId = undefined,
) => ({
  type: CSW_CREATE_LABEL_FAILURE,
  fulfillmentPlanId,
  errorMessages,
  autoPrint,
  isLabelPurchaseComplete,
  purchaseCorrelationId,
});

export const saveMultiPackageSet = (fulfillmentPlanId, packages) => {
  const optimisticId = GuidService.newGuid();
  return {
    fulfillmentPlanId,
    type: CSW_SAVE_MULTIPACKAGE_SET,
    meta: {
      ...makeOptimisticMeta(fulfillmentPlanId, optimisticId),
    },
    packages,
  };
};

export const savePackageSetSuccess = (packageSet) => ({
  type: CSW_SAVE_PACKAGE_SET_SUCCESS,
  packageSet,
});

export const changeInsuredValue = (fulfillmentPlanId, insuranceValue, index = 0) => ({
  fulfillmentPlanId,
  index,
  insuranceValue,
  type: CSW_CHANGE_INSURED_VALUE,
});

export const updateFulfillmentPlanAndRateSuccess = (fulfillmentPlanId, rateMeta) => ({
  type: CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_SUCCESS,
  fulfillmentPlanId,
  rateMeta,
});

export const updateFulfillmentPlanAndRateFailure = (fulfillmentPlanId, errors) => ({
  type: CSW_UPDATE_FULFILLMENT_PLAN_AND_RATE_FAILURE,
  errors,
  fulfillmentPlanId,
});

export const updateServiceAndOtherShippingOptions = (fulfillmentPlanId, serviceId, sellerLabelProviderId) => {
  return {
    fulfillmentPlanId,
    sellerLabelProviderId,
    serviceId,
    type: CSW_UPDATE_SERVICE_AND_OTHER_SHIPPING_OPTIONS,
  };
};

export const resetCSW = (fulfillmentPlanId) => ({
  type: CSW_RESET,
  fulfillmentPlanId,
});

export const CSW_ENTER_RETURNS_MODE = 'CSW_ENTER_RETURNS_MODE';
export const enterReturnsMode = (salesOrderId, shipmentItemsForReturn, shipTo) => ({
  type: CSW_ENTER_RETURNS_MODE,
  salesOrderId,
  shipmentItemsForReturn,
  shipTo,
});

export const exitReturnsMode = (fulfillmentPlanId) => ({
  type: CSW_EXIT_RETURNS_MODE,
  fulfillmentPlanId,
});

export const CSW_SEND_EXTERNAL_FULFILLMENT = 'CSW_SEND_EXTERNAL_FULFILLMENT';
export const sendExternalFulfillment = (fulfillmentPlanId) => ({
  type: CSW_SEND_EXTERNAL_FULFILLMENT,
  fulfillmentPlanId,
});

export const CSW_SEND_EXTERNAL_FULFILLMENT_SUCCESS = 'CSW_SEND_EXTERNAL_FULFILLMENT_SUCCESS';
export const sendExternalFulfillmentSuccess = (fulfillmentPlanId, notificationId) => ({
  type: CSW_SEND_EXTERNAL_FULFILLMENT_SUCCESS,
  fulfillmentPlanId,
  notificationId,
});

export const CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_SUCCESS = 'CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_SUCCESS';
export const externalFulfillmentSaveAndRateSuccess = (fulfillmentPlanId, rateMeta) => ({
  type: CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_SUCCESS,
  fulfillmentPlanId,
  rateMeta,
});

export const CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_FAILURE = 'CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_FAILURE';
export const externalFulfillmentSaveAndRateFailure = (fulfillmentPlanId, errors) => ({
  type: CSW_EXTERNAL_FULFILLMENT_SAVE_AND_RATE_FAILURE,
  fulfillmentPlanId,
  errors,
});

export const CSW_ENTER_EXTERNAL_FULFILLMENT_MODE = 'CSW_ENTER_EXTERNAL_FULFILLMENT_MODE';
export const enterExternalFulfillmentMode = (fulfillmentPlanId) => ({
  type: CSW_ENTER_EXTERNAL_FULFILLMENT_MODE,
  fulfillmentPlanId,
});

export const CSW_EXIT_EXTERNAL_FULFILLMENT_MODE = 'CSW_EXIT_EXTERNAL_FULFILLMENT_MODE';
export const exitExternalFulfillmentMode = (fulfillmentPlanId) => ({
  type: CSW_EXIT_EXTERNAL_FULFILLMENT_MODE,
  fulfillmentPlanId,
});

export const CSW_SET_SHIPPING_DROPDOWN_PREFERENCE = 'CSW_SET_SHIPPING_DROPDOWN_PREFERENCE';
export const setShippingDropdownPreference = (preference) => ({
  type: CSW_SET_SHIPPING_DROPDOWN_PREFERENCE,
  preference,
});

export const CSW_DELETE_PACKAGE_SET_SUCCESS = 'CSW_DELETE_PACKAGE_SET_SUCCESS';
export const deletePackageSetSuccess = (packageSetId) => ({
  type: CSW_DELETE_PACKAGE_SET_SUCCESS,
  packageSetId,
});

export const CSW_UPDATE_NEEDS_CUSTOMS_REQUIREMENTS = 'CSW_UPDATE_NEEDS_CUSTOMS_REQUIREMENTS';
export const updateNeedsCustomsRequirements = (fulfillmentPlanId, updatedNeedsCustomsRequirements) => ({
  type: CSW_UPDATE_NEEDS_CUSTOMS_REQUIREMENTS,
  fulfillmentPlanId,
  updatedNeedsCustomsRequirements,
});

export const CSW_GET_BEST_WAY_TO_SHIP_ON_MOUNT = 'CSW_GET_BEST_WAY_TO_SHIP_ON_MOUNT';
export const getBestWayToShipOnMount = (fulfillmentPlanId, payload, cswTypeId) => ({
  type: CSW_GET_BEST_WAY_TO_SHIP_ON_MOUNT,
  fulfillmentPlanId,
  payload,
  cswTypeId,
});

export const CSW_SAVE_CONFIG_WITH_PAYLOAD = 'CSW_SAVE_CONFIG_WITH_PAYLOAD';
export const saveConfigWithPayload = (
  fulfillmentPlanId,
  shippingConfig,
  isEnteringExternalFulfillment,
  cswTypeId,
  sendAnalytics,
  doNotCallForRate,
) => {
  const optimisticId = GuidService.newGuid();
  return {
    type: CSW_SAVE_CONFIG_WITH_PAYLOAD,
    fulfillmentPlanId,
    isEnteringExternalFulfillment,
    payload: shippingConfig,
    cswTypeId,
    doNotCallForRate,
    meta: {
      optimistic: BEGIN_OPTIMISTIC_UPDATE,
      optimisticId,
      onSuccess: () => ({
        type: 'CSW_SAVE_CONFIG_WITH_PAYLOAD_SUCCESS',
        meta: {
          optimistic: COMMIT_OPTIMISTIC_UPDATE,
          optimisticId,
        },
      }),
      onError: (error) => ({
        type: CSW_RATE_ACTION_FAILURE,
        payload: { fulfillmentPlanId, error: new Error(error) },
        meta: {
          optimistic: REVERT_OPTIMISTIC_UPDATE,
          optimisticId,
          error: true,
        },
      }),
      onFlush: () => {
        return {
          type: 'OPTIMISTIC_FLUSH',
          meta: {
            optimistic: FLUSH_OPTIMISTIC_UPDATE,
            optimisticId,
          },
        };
      },
      sendAnalytics,
    },
  };
};

export const CSW_GET_RATE_WITH_PAYLOAD = 'CSW_GET_RATE_WITH_PAYLOAD';
export const getRateWithPayload = (fulfillmentPlanId, payload, cswTypeId) => {
  return {
    type: CSW_GET_RATE_WITH_PAYLOAD,
    fulfillmentPlanId,
    payload,
    cswTypeId,
  };
};

export const CSW_SYNC_CONTEXT_TO_REDUCER = 'CSW_SYNC_CONTEXT_TO_REDUCER';
export const syncContextToReducer = (fulfillmentPlanId, payload) => ({
  type: CSW_SYNC_CONTEXT_TO_REDUCER,
  fulfillmentPlanId,
  payload,
});

export const CSW_COMPARE_RATES = 'CSW_COMPARE_RATES';
export const cswCompareRates = (fulfillmentPlanId) => ({
  type: CSW_COMPARE_RATES,
  fulfillmentPlanId,
});

export const createTestLabel = (fulfillmentPlanId) => ({
  type: CSW_CREATE_TEST_LABEL,
  fulfillmentPlanId,
});

export const createTestLabelSuccess = (fulfillmentPlanId) => ({
  type: CSW_CREATE_TEST_LABEL_SUCCESS,
  fulfillmentPlanId,
});

export const CSW_SET_PENDING_DOCUMENTS = 'CSW_SET_PENDING_DOCUMENTS';
export const cswSetPendingDocuments = (fulfillmentPlanId, pendingDocument) => ({
  type: CSW_SET_PENDING_DOCUMENTS,
  fulfillmentPlanId,
  pendingDocument,
});

export const CSW_ADD_RATE_SHOPPER_SERVICE_AND_RERATE = 'CSW_ADD_RATE_SHOPPER_SERVICE_AND_RERATE';
export const cswAddRateShopperServiceAndRerate = (fulfillmentPlanId, serviceCollectionGuid, serviceToAddToServiceCollection) => ({
  type: CSW_ADD_RATE_SHOPPER_SERVICE_AND_RERATE,
  fulfillmentPlanId,
  serviceCollectionGuid,
  serviceToAddToServiceCollection,
});
